// File: webelieve-frontend/src/features/calendar/lexical/plugins/ContextMenuSelectionPlugin.tsx
// Lexical plugin that intercepts right-click on selected text and fires a callback
// with the selection text and click coordinates. If no text is selected, the
// browser's default context menu is shown.

import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getSelection, $isRangeSelection } from 'lexical';

export interface ContextMenuSelectionData {
  x: number;
  y: number;
  selectedText: string;
}

interface ContextMenuSelectionPluginProps {
  onContextMenu: (data: ContextMenuSelectionData) => void;
}

export default function ContextMenuSelectionPlugin({ onContextMenu }: ContextMenuSelectionPluginProps) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    const rootElement = editor.getRootElement();
    if (!rootElement) return;

    const handler = (event: MouseEvent) => {
      const text = editor.getEditorState().read(() => {
        const selection = $getSelection();
        if (!$isRangeSelection(selection)) return '';
        return selection.getTextContent().trim();
      });

      if (!text) return; // Let browser default menu show

      event.preventDefault();
      onContextMenu({ x: event.clientX, y: event.clientY, selectedText: text });
    };

    rootElement.addEventListener('contextmenu', handler);
    return () => rootElement.removeEventListener('contextmenu', handler);
  }, [editor, onContextMenu]);

  return null;
}
